// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mbsI","col":"styles_col__35XpZ","actions":"styles_actions__2pWLY","conflict":"styles_conflict__10nJc"};